import * as React from 'react';
import { LAYOUT } from '../../../ui/layout';
import { Skeleton } from '../../../ui/Skeleton';
import { Stage } from '../../../ui/Stage';
import { Text } from '../../../ui/Text';
import { zVar } from '../../../ui/theme';
import { computeSeats } from './seat-layout';
import { TableBackground } from './TableBackground';

/*
 * BoardSkeleton — the table with placeholder seats, shown while the first game
 * state is in flight. The real seat count isn't known yet, so it draws the
 * common four; the felt and geometry are already correct, which makes the load
 * read as "filling in" rather than a blank screen.
 */

const SKELETON_SEATS = 4;

export const BoardSkeleton: React.FC = () => (
  <Stage>
    <TableBackground />

    {computeSeats(SKELETON_SEATS).map((seat) => (
      <div
        key={seat.index}
        style={{
          position: 'absolute',
          left: seat.avatar.x,
          top: seat.avatar.y,
          transform: 'translate(-50%, -50%)',
          zIndex: zVar('z-seats'),
        }}
      >
        <Skeleton width={LAYOUT.avatar} height={LAYOUT.avatar} radius="var(--radius-pill)" />
      </div>
    ))}

    <div
      style={{
        position: 'absolute',
        left: LAYOUT.table.cx,
        top: LAYOUT.table.cy,
        transform: 'translate(-50%, -50%)',
        zIndex: zVar('z-trick'),
      }}
    >
      <Text variant="muted">Dealing you in…</Text>
    </div>
  </Stage>
);

export default BoardSkeleton;
